<template>
  <div class="mb-4">
    <box tag="section">
      <div
        v-if="userRejected"
        class="alert alert-danger status-bar d-flex align-items-center mb-4"
      >
        <svg-icon icon="error" class="mr-3 text-danger icon-3x" />
        <div>
          <div class="mb-2">{{ $parseMessage(rejectedReason) }}</div>
          <div>
            {{ $t('retryJoin') }}
            {{
              $date.format(new Date(participant.nextJoinAt), 'DD.MM.YYYY HH:mm')
            }}
          </div>
        </div>
      </div>
      <header class="d-flex align-items-center">
        <div class="mr-auto">
          <dates-range :start="task.startAt" :end="task.endAt" />
          <router-link
            :to="{
              name: 'campaign-task-statistics',
              params: {
                id: $route.params.id,
                name: $route.params.name,
                taskId: task.id
              }
            }"
            class="d-block participants-link text-nowrap text-5-alt"
          >
            <participants :participants="task.participants" />
          </router-link>
        </div>
        <div>
          <b-row class="cols align-items-center justify-content-end">
            <b-col style="flex-grow:0" v-if="$can('join', 'Task')">
              <button-join
                :join="joined"
                @join="tryJoin"
                @leave="tryLeave"
                :is-pending="joinPending"
                :user-left="userLeft"
                :user-rejected="userRejected"
                :participant="participant"
              />
            </b-col>
          </b-row>
        </div>
      </header>
      <hr />
      <template v-if="accessToProgress">
        <task-progress :current-task-id="task.id" class="mb-6" />
      </template>
      <template v-if="!accessToProgress">
        <section v-html="task.description"></section>
        <router-link
          v-if="
            $route.params.name === 'twitter' ||
              $route.params.name === 'instagram'
          "
          :to="{
            name: 'task-tutorial',
            params: {
              task: $route.params.name
            }
          }"
          class="btn-link-alt mt-4"
        >
          {{ $t('taskTutorial') }}
        </router-link>
        <slot name="rules">
          <template v-if="globalRules.length">
            <h2 class="mt-6">{{ $t('rulesForJoin') }}</h2>
            <div v-for="rule in globalRules" :key="rule.name">
              <span class="text-light">{{ rule.name }}: </span>
              <strong>{{ rule.value }}</strong>
            </div>
          </template>
        </slot>
      </template>
    </box>
    <box v-if="accessToProgress">
      <section v-html="task.description"></section>
      <router-link
        v-if="
          $route.params.name === 'twitter' || $route.params.name === 'instagram'
        "
        :to="{
          name: 'task-tutorial',
          params: {
            task: $route.params.name
          }
        }"
        class="btn-link-alt mt-4"
      >
        {{ $t('taskTutorial') }}
      </router-link>
      <slot name="rules">
        <template v-if="globalRules.length">
          <h2 class="mt-6">{{ $t('rulesForJoin') }}</h2>
          <div v-for="rule in globalRules" :key="rule.name">
            <span class="text-light">{{ rule.name }}: </span>
            <strong>{{ rule.value }}</strong>
          </div>
        </template>
      </slot>
    </box>
  </div>
</template>

<script>
import Participants from '@/components/BountyCampaign/Participants.vue';
import TaskProgress from './../../components/TaskProgress.vue';
import ButtonJoin from './../../components/Task/ButtonJoin.vue';
import DatesRange from '@/components/DatesRange.vue';
import { mapGetters } from 'vuex';

export default {
  props: {
    task: {
      type: Object,
      default: null
    },
    tryLeave: {
      type: Function,
      default: () => ({})
    },
    tryJoin: {
      type: Function,
      default: () => ({})
    },
    globalRules: {
      type: Array,
      default: () => []
    },
    joined: {
      type: Boolean,
      default: false
    },
    joinPending: {
      type: Boolean,
      default: false
    },
    userLeft: {
      type: Boolean,
      default: false
    },
    userRejected: {
      type: Boolean,
      default: false
    },
    rejectedReason: {
      type: Object,
      default: () => {}
    },
    participant: {
      type: Object,
      default: () => {}
    }
  },

  components: {
    Participants,
    TaskProgress,
    ButtonJoin,
    DatesRange
  },

  computed: {
    ...mapGetters({
      role: 'role'
    }),
    accessToProgress() {
      return (
        this.$can('view', 'TaskProgress') && this.joined && !this.joinPending
      );
    },
    accessToJoin() {
      return this.$store.getters.role === 'bounty-hunter';
    }
  }
};
</script>

<style lang="scss">
.participants-link {
  span,
  i {
    transition: color 0.2s;
  }

  &:hover {
    text-decoration: none;

    span,
    i {
      color: $primary;
    }
  }
}
.status-bar {
  > div {
    div {
      font-size: 0.9rem;
      line-height: 1.2;

      &:last-child {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
